import examineProblemDlg from './src/main.js'
export default examineProblemDlg



// WEBPACK FOOTER //
// ./src/components/examineProblemDlg/index.js